<template>
    <v-dialog v-model="deveMostrarModalReajusteEmLote" persistent max-width="300px">
        <v-card>
            <v-card-title class="modal-title primary py-1" primary-title>
                <span>Reajuste</span>
                <v-spacer></v-spacer>
                <v-btn small icon @click.stop="$emit('fecharModalReajusteEmLote')">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap style="background-color: white;">
                        <v-flex xs12 sm12>
                            <v-select
                                v-model="dadosReajusteEmLote.anoBase"
                                label="Ano Base"
                                :disabled="anosPermitidos.length <= 1"
                                :items="anosPermitidos"
                                name="Ano Base"
                                v-validate="'required'"
                                @change="dadosReajusteEmLote.anoIndicador = $event-1"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field
                                v-model="dadosReajusteEmLote.anoIndicador"
                                label="Ano Indicador"
                                disabled
                                readonly
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-select v-model="dadosReajusteEmLote.indicador"
                                      :items="['IPCA']"
                                      :menu-props="{ top: false, offsetY: true }"
                                      label="Indicador"/>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field v-model.number="dadosReajusteEmLote.percentualReajuste"
                                          placeholder="Exemplo: 10,50"
                                          name="Percentual Reajuste"
                                          type="text"
                                          @input="dadosReajusteEmLote.percentualReajuste = $event.replace(',', '.')"
                                          min="0"
                                          class="required-field"
                                          key="Percentual Reajuste"
                                          v-mask="['#,##', '##,##']"
                                          :rules="[v => !!v || 'Percentual Reajuste é obrigatório']"
                                          v-validate="'required|'"
                                          :error-messages="errors.collect('Percentual Reajuste')"
                                          label="Percentual Reajuste">
                                <template v-slot:append>
                                    <v-icon color="primary">percent</v-icon>
                                </template>
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions class="modal-actions pa-3">
                <v-btn flat outline color="botao-cancelar-color" @click.stop="$emit('fecharModalReajusteEmLote')">Cancelar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" depressed @click.stop="validarESalvar">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


</template>

<script>
export default {
    name: 'ModalReajusteEmLote',
    inject: ['$validator'],
    props: ['dadosReajusteEmLote', 'deveMostrarModalReajusteEmLote', 'historicoUltimoAnoReajuste'],
    data() {
        return {
            anosPermitidos: [],
        }
    },
    mounted() {
        this.setup()
    },
    methods: {
        async validarESalvar() {
            const ehFormularioValido = await this.$validator.validateAll()
            if(!ehFormularioValido)
                throw new Error('Preencha os campos obrigatórios')

            this.$emit('salvarReajusteEmLote')
            this.fecharModalReajusteEmLote()
        },
        fecharModalReajusteEmLote() {
            this.$validator.errors.clear()
            this.$validator.reset()

            this.$emit('fecharModalReajusteEmLote')
        },
        setup(){
            if(this.historicoUltimoAnoReajuste.length > 0) {
                const primeiro = this.historicoUltimoAnoReajuste[0]

                if(this.dadosReajusteEmLote.anoBase !== primeiro.ano){
                    this.dadosReajusteEmLote.anoBase = primeiro.ano + 1
                    this.dadosReajusteEmLote.anoIndicador = primeiro.ano
                    this.anosPermitidos = [primeiro.ano, primeiro.ano + 1]
                }
            }
            else{
                this.anosPermitidos = [(new Date()).getFullYear()]
            }
        }
    },
    watch: {
        'historicoUltimoAnoReajuste'(){
            this.setup()
        }
    }

}
</script>

<style scoped lang="stylus">

</style>